



























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import stringCompare from 'src/assets/stringCompare'
import AttendeesListItem from 'components/presenter/item/session/manager/AttendeesListItem.vue'
import { Item, Session, SessionAttendee, Student } from 'src/graphql/types'

@Component({
  components: {
    AttendeesListItem
  }
})
export default class SessionManagerAttendeesList extends Vue {
  viewport = store.viewport
  students: Student[] = []
  studentsLoading = false
  studentsView = false
  filter = ''

  @Prop()
  readonly topic!: Item

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendees!: { [key: string]: SessionAttendee }

  @Prop()
  readonly currSlide!: Json

  @Prop()
  readonly safeArea!: boolean

  get height () {
    return this.viewport.height ? `${this.viewport.height}px` : '100%'
  }

  get attendeeCount () {
    return Object.keys(this.attendees).length
  }

  get attendeesFiltered () {
    const attendees = []
    if (this.filter) {
      const filter = this.filter.toLowerCase()
      attendees.push(...Object.values(this.attendees).filter(a => `${a.publicProfile?.name || ''} ${a.contactName || ''}`.toLowerCase().includes(filter)))
    } else {
      attendees.push(...Object.values(this.attendees))
    }
    attendees.sort((a,b) => stringCompare(a.publicProfile?.name || '', b.publicProfile?.name || ''))
    return attendees
  }

  @Watch('studentsView')
  async loadStudents (studentsView: boolean) {
    if (studentsView) {
      this.studentsLoading = true
      this.students = []
      // await load students list (not attendees yet)
      this.studentsLoading = false
    }
  }

  async add (student: Student) {
    // add student as attendee
    // remove student from students list
  }
}
